import {postsPaywallService} from '../services'

const state = {
    loading: false,
    settings: {
        enabled: false,
        unknown_limit: 0,
        unknown_enabled: false,
        free_limit: 0,
        free_enabled: false,
        popups: {
            subscribe: {},
            upgrade: {},
        }
    },
    statistics: {
        shown: null,
        count_free: null,
        count_paid: null,
    },
}

const actions = {

    loadSettings({ dispatch, commit }) {
        commit('loadSettingsRequest')
        return postsPaywallService.loadSettings().then(
            response => {
                commit('loadSettingsSuccess', response.paywall)
                commit('loadStatisticsSuccess', response.statistics)
            },
            error => {
                commit('loadSettingsError')
                dispatch('alert/error', 'Unable to load paywall settings: ' + error, { root: true })
            }
        )
    },

    update({ dispatch, commit }, params) {
        commit('updateRequest')
        return postsPaywallService.update(params).then(
            response => {
                commit('updateSuccess', response.paywall)
                dispatch('alert/success', 'Paywall settings updated successfully', { root: true })
                return response
            },
            error => {
                commit('updateError')
                dispatch('alert/error', 'Unable to update paywall settings: ' + error, { root: true })
            }
        )
    },
}

const mutations = {
    loadSettingsRequest (state) {
        state.loading = true
    },
    loadSettingsError (state) {
        state.loading = false
    },
    loadSettingsSuccess (state, data) {
        state.loading = false
        state.settings = data
    },
    loadStatisticsSuccess (state, data) {
        state.loading = false
        state.statistics = data
    },
    updateRequest (state) {
        state.loading = true
    },
    updateError (state) {
        state.loading = false
    },
    updateSuccess (state, data) {
        state.loading = false
        state.settings = data
    },
}

const getters = {
    isBusy (state) {
        return state.loading === true
    },
    getSettings (state) {
        return state.settings
    },
    getStatistics (state) {
        return state.statistics
    },
}


export const postsPaywallModule = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
